module.exports = __webpack_public_path__ + "img/kh.28aa84a3.jpg";